var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    { attrs: { title: _vm.title, loading: _vm.loadingMargin } },
    [
      _c("template", { attrs: { slot: "body" }, slot: "body" }, [
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.saveMargin($event)
              }
            }
          },
          [
            _c(
              "sc-field",
              [
                _c(
                  "sc-radio",
                  {
                    attrs: { "native-value": null },
                    model: {
                      value: _vm.margin.marginType,
                      callback: function($$v) {
                        _vm.$set(_vm.margin, "marginType", $$v)
                      },
                      expression: "margin.marginType"
                    }
                  },
                  [_vm._v("\n          Padrão do sistema\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "sc-field",
              [
                _c(
                  "sc-radio",
                  {
                    staticClass: "configuration-invoice__radio",
                    attrs: { "native-value": "ABSOLUTE" },
                    model: {
                      value: _vm.margin.marginType,
                      callback: function($$v) {
                        _vm.$set(_vm.margin, "marginType", $$v)
                      },
                      expression: "margin.marginType"
                    }
                  },
                  [
                    _vm._v(
                      "\n          Considera dentro da margem, até\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  [
                    _c("sc-input-currency", {
                      staticClass: "input",
                      attrs: { disabled: _vm.margin.marginType !== "ABSOLUTE" },
                      model: {
                        value: _vm.margin.marginFixedValue,
                        callback: function($$v) {
                          _vm.$set(_vm.margin, "marginFixedValue", $$v)
                        },
                        expression: "margin.marginFixedValue"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "sc-field",
              [
                _c(
                  "sc-radio",
                  {
                    staticClass: "configuration-invoice__radio",
                    attrs: { "native-value": "PERCENTAGE" },
                    model: {
                      value: _vm.margin.marginType,
                      callback: function($$v) {
                        _vm.$set(_vm.margin, "marginType", $$v)
                      },
                      expression: "margin.marginType"
                    }
                  },
                  [
                    _vm._v(
                      "\n          Considera dentro da margem o percentual de\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  [
                    _c("sc-input-percent", {
                      staticClass: "input",
                      attrs: {
                        disabled: _vm.margin.marginType !== "PERCENTAGE"
                      },
                      model: {
                        value: _vm.margin.marginPercentageValue,
                        callback: function($$v) {
                          _vm.$set(_vm.margin, "marginPercentageValue", $$v)
                        },
                        expression: "margin.marginPercentageValue"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "sc-field",
              [
                _c(
                  "sc-radio",
                  {
                    staticClass: "configuration-invoice__radio",
                    attrs: { "native-value": "MIXED_GREATER" },
                    model: {
                      value: _vm.margin.marginType,
                      callback: function($$v) {
                        _vm.$set(_vm.margin, "marginType", $$v)
                      },
                      expression: "margin.marginType"
                    }
                  },
                  [
                    _vm._v(
                      "\n          Considera dentro da margem uma das opções\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  [
                    _c("sc-input-currency", {
                      staticClass: "input",
                      attrs: {
                        disabled: _vm.margin.marginType !== "MIXED_GREATER"
                      },
                      model: {
                        value: _vm.margin.marginMixedFixedValue,
                        callback: function($$v) {
                          _vm.$set(_vm.margin, "marginMixedFixedValue", $$v)
                        },
                        expression: "margin.marginMixedFixedValue"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "control" }, [
                      _c("span", { staticClass: "button is-static" }, [
                        _vm._v("ou")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("sc-input-percent", {
                      staticClass: "input",
                      attrs: {
                        disabled: _vm.margin.marginType !== "MIXED_GREATER"
                      },
                      model: {
                        value: _vm.margin.marginMixedPercentageValue,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.margin,
                            "marginMixedPercentageValue",
                            $$v
                          )
                        },
                        expression: "margin.marginMixedPercentageValue"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "buttons is-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: { "is-loading": _vm.loadingMarginSave }
                },
                [_vm._v("Salvar")]
              )
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c8cda35", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8cda35","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/blocks/ConfigurationInvoiceMargins.vue
// module id = null
// module chunks = 